import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import CLoseImg from "../../../assets/images/closeIconModal.svg";
import searchIcon from "../../../assets/images/search-normal.png";
import "./ApplyProductModal.scss";
import { useEffect, useState } from "react";
import axios from "axios";

const ApplyProductModal = ({
  show,
  onCloseClick,
  productData,
  onSelectProducts,
  preSelectedProducts = [],
  onSearch,
  searchTerm,
}: any) => {
  const [selectedProducts, setSelectedProducts] = useState<any[]>([]);

  useEffect(() => {
    if (show && preSelectedProducts?.length > 0) {
      setSelectedProducts(preSelectedProducts);
    }
  }, [show, preSelectedProducts]);

const handleSelectAll = (e: any) => {
  if (e.target.checked) {
    setSelectedProducts(productData); // Select all
  } else {
    setSelectedProducts([]); // Deselect all
  }
};

const handleCheckboxChange = (product: any, isChecked: boolean) => {
  if (isChecked) {
    setSelectedProducts((prev: any) => [...prev, product]);
  } else {
    setSelectedProducts((prev: any) =>
      prev.filter((p: any) => p._id !== product._id)
    );
  }
};

  const handleOkClick = () => {
    onSelectProducts(selectedProducts);
    onCloseClick(false);
  };

  return (
    <Modal isOpen={show} centered className="ApplyProductMOdal">
      <ModalBody className="modal_Body">
        <img
          data-testing-id="closeIcon"
          onClick={() => onCloseClick(false)}
          className="closeIconModal"
          src={CLoseImg}
          alt=""
        />
        <div className="mainkeywod">
          <h1>Add Products</h1>
          <div className="selectMain">
            <select className="widf" data-testing-id="category.keyword">
              <option value="">
                Please select category or search with keyword
              </option>
            </select>
            <div className="searchAndSelect">
              <select data-testing-id="searchAndSelect">
                <option value="">Product Name</option>
              </select>
              <div className="input">
                <input
                  data-testing-id="produc.SearchON"
                  type="text"
                  placeholder="Please Input"
                  value={searchTerm}
                  onChange={(e) => onSearch(e.target.value)}
                />
                <img src={searchIcon} alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="AddProductListing_Main">
          <table className="w-100">
            <thead>
              <tr>
                <th>
                  <div className="d-flex gap-2">
                    <input
                      type="checkbox"
                      className="sellerCheckbox m-0 form-check-input"
                      data-testing-id="selectAllInput_BlockedKeyword"
                      onChange={handleSelectAll}
                      checked={
                        productData?.length > 0 &&
                        productData.every((product: any) =>
                          selectedProducts.some(
                            (selected: any) => selected._id === product._id
                          )
                        )
                      }
                    />
                    <p>Product Info</p>
                  </div>
                </th>
                <th>Retail Price</th>
                <th>Sale Price</th>
                <th>Stock</th>
              </tr>
            </thead>
            <tbody>
              {productData && productData.length > 0 ? (
                productData.map((product: any, index: number) => (
                  <tr key={index}>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                     <input
            type="checkbox"
            className="sellerCheckbox m-0 form-check-input"
            data-testing-id="selectProductCheckbox"
            checked={selectedProducts.some((p: any) => p._id === product._id)}
            onChange={(e) =>
              handleCheckboxChange(product, e.target.checked)
            }
          />

                        <img
                          src={product?.image}
                          style={{ width: "40px" }}
                          alt=""
                        />
                        <p>{product?.nameEn}</p>
                      </div>
                    </td>
                    <td>
                      <p className="text-secondary fw-bold">{product?.price}</p>
                    </td>
                    <td>
                      <p>{product?.price}</p>
                    </td>
                    <td>
                      <p>{product?.stock}</p>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="text-center p-2 w-100">
                    No Product Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="rowitem">
          <h1>
            Selection rows: <span>{selectedProducts.length} item(s)</span>
          </h1>
          <div className="butman">
            <button className="butoon" onClick={handleOkClick}>
              Ok
            </button>
            <button className="ancel" onClick={() => onCloseClick(false)}>
              Cancel
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

ApplyProductModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.bool,
  productData: PropTypes.array,
  onSelectProducts: PropTypes.func,
  preSelectedProducts: PropTypes.array,
  onSearch: PropTypes.any,
  searchTerm: PropTypes.any,
};

export default ApplyProductModal;
